import invariant from 'invariant';
import { isUUID } from '@frameio/utils/formatters';
// @todo (WEB-1045): Add condensed UUID support to routes
// import { toCondensedUUID } from '@frameio/utils/formatters/uuid';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

// @todo (WEB-1045): Remove when condensed UUID support is added to routes
const toCondensedUUID = (uuid: string): string => uuid;

export type TrashGetLinkParams =
  /**
   * FolderPage
   * The root folder of a project
   * /project/:projectId/recently-deleted
   */
  | {
      page: 'trash';
      projectId: string;
    }
  /**
   * FolderPage
   * A subfolder of a project
   * /project/:projectId/recently-deleted/:folderAssetId
   */
  | {
      page: 'trash';
      projectId: string;
      folderAssetId: string;
    };

export const getLinkForTrashFolder = (
  params: TrashGetLinkParams
): ValidHref => {
  // Subfolder
  if ('folderAssetId' in params && params.folderAssetId) {
    const { projectId, folderAssetId } = params;
    invariant(projectId, 'projectId is required');

    // /project/:projectId/recently-deleted/:folderAssetId
    const _projectId = toCondensedUUID(projectId);

    const _folderAssetId = toCondensedUUID(folderAssetId);

    return createUrl({
      pathname: `/project/${_projectId}/recently-deleted/${_folderAssetId}`,
    });
  }

  // Root trash folder
  const { projectId } = params;
  invariant(projectId, 'projectId is required');

  // /project/:projectId
  const _projectId = toCondensedUUID(projectId);
  return createUrl({
    pathname: `/project/${_projectId}/recently-deleted`,
  });
};

export const isTrashPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');
  if (parts[1] !== 'project' || parts[3] !== 'recently-deleted') return false;

  // /project/:projectId/recently-deleted
  if (parts.length === 4 && isUUID(parts[2]) && parts[3] === 'recently-deleted')
    return true;

  // /project/:projectId/recently-deleted/:folderAssetId;
  if (
    parts.length === 5 &&
    isUUID(parts[2]) &&
    parts[3] === 'recently-deleted' &&
    isUUID(parts[4])
  )
    return true;

  return false;
};
